interface CustomHeaders {
  headers?: Record<string, string | null>;
}

export interface GetParams extends CustomHeaders {
  queryStringParameters?: Record<string, unknown>;
}

export interface DelParams extends CustomHeaders {
  queryStringParameters?: Record<string, unknown>;
}

export interface PostParams extends CustomHeaders {
  body?: unknown;
  queryStringParameters?: Record<string, unknown>;
}
export interface PutParams extends PostParams {}

// Error from backend error middleware
export interface BackendError {
  name: string;
  message: string;
  errors: string[];
}

export enum ApiSourceEnum {
  API_AUTH = '',
  API_UNAUTH = 'public/',
}

export interface FetchRequest {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  url: string;
  businessId: number | undefined;
  body?: unknown;
  queryStringParameters?: Record<string, unknown>;
  headers?: Record<string, string | null>;
}
